import {IOrdenesRefMaq} from './../../modelos/IOrdenesRefMaq';
import {OrdenesReferenciaMaquinaService} from './../../services/ordenes-referencia-maquina.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Component, OnInit} from '@angular/core';
import {moduloGaritas} from '../../diccionarios/balanzaModulo.js';
import {formatDate} from '@angular/common';
import {MaterialService} from '../../services/material.service';

@Component({
  selector: 'app-ordenes-referencia-maquina',
  templateUrl: './ordenes-referencia-maquina.component.html',
  styleUrls: ['./ordenes-referencia-maquina.component.scss'],
})
export class OrdenesReferenciaMaquinaComponent implements OnInit {
  public loading: boolean = false;

  public DAT_TITULOS: any = moduloGaritas.titulos.ordenesReferenciaCompra;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public DAT_AG_GRID: any = moduloGaritas.agGrid;

  public columnDefs: any[] = [];
  public rowData: any[] = [];
  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public tituloModal: string;
  public formOrdernes = new FormGroup({
    numOrd: new FormControl(null, Validators.required),
    fechaOrd: new FormControl(null, Validators.required),
    material: new FormControl(null, [Validators.required, Validators.pattern(/^[a-zA-Z0-9/]+$/)]),
    materialDescripcion: new FormControl(null, Validators.required),
    cantidad: new FormControl(null, Validators.required),
  });
  private isCreate: boolean;

  constructor(
    private _util: UtilsService,
    private ordenesReferenciaMaquinaS: OrdenesReferenciaMaquinaService,
    private materialS: MaterialService
  ) {
  }

  get material() {
    return this.formOrdernes.get('material');
  }

  get cantidad() {
    return this.formOrdernes.get('cantidad');
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Orden',
        field: 'numOrd',
        sortable: true,
        filter: true,
        width: 80,
      },
      {
        headerName: 'Fecha',
        field: 'fechaOrd',
        sortable: true,
        filter: true,
        cellRenderer: (data) => {
          return formatDate(new Date(data.value), 'dd-MM-yyyy', 'en')
        }
      },
      {
        headerName: 'Material',
        field: 'material',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 40,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 40,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger,
        },
      },
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  }

  ngOnInit(): void {
    this.formOrdernes.get('numOrd')?.disable({onlySelf: true});
    this.formOrdernes.get('fechaOrd')?.disable({onlySelf: true});
    this.girdComponent();
    this.obtenerOrdenesReferenciaMaquina();
  }

  searchMaterial() {
    this.materialS.obtenerPorId(
      this.material.value
    ).subscribe(
      resp => {
        if (resp) {
          this.formOrdernes.get('materialDescripcion').setValue(`${resp.idMaterial.trim()} - ${resp.dscaMaterial.trim()}`)
          return;
        }
        this.formOrdernes.get('materialDescripcion').setValue('');
        this._util.mensajeErroToast('El material ingresado es incorrecto.');
      },
      error => {
        this.formOrdernes.get('materialDescripcion').setValue('');
        this._util.mensajeErroToast('Ocurrió un error inesperado al buscar proveedor, inténtelo nuevamente.');
      }
    );
  }

  obtenerOrdenesReferenciaMaquina() {
    this.loading = true;
    this.ordenesReferenciaMaquinaS.obtener().subscribe(
      (resp) => {
        this.rowData = resp;
        this.loading = false;
      },
      (error) => {
        this.rowData = [];
        this.loading = false;
      }
    );
  }

  guardarCrear() {
    this.loading = true;
    if (this.formOrdernes.invalid) return;
    let data: IOrdenesRefMaq = this.formOrdernes.getRawValue();
    data.fechaOrd = data.fechaOrd.split(' ')[0].split('-').reverse().join('-') + 'T' + data.fechaOrd.split(' ')[1];

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        text: `Material: ${data.material}, Cantidad: ${data.cantidad}`,
        action: this.DAT_BTNS.nuevo,
        funcion: this.ordenesReferenciaMaquinaS.crear(data),
      })
      .then(() => {
        this.obtenerOrdenesReferenciaMaquina();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        console.log("entró");

        this.loading = false;
      });
  }

  guardarEditar() {
    this.loading = true;
    if (this.formOrdernes.invalid) return;
    let data: IOrdenesRefMaq = this.formOrdernes.getRawValue();
    data.fechaOrd = data.fechaOrd.split(' ')[0].split('-').reverse().join('-') + 'T' + data.fechaOrd.split(' ')[1];

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.actualizar,
        text: `Material: ${data.material}, Cantidad: ${data.cantidad}`,
        action: this.DAT_BTNS.editar,
        funcion: this.ordenesReferenciaMaquinaS.editar(
          data
        ),
      })
      .then(() => {
        this.obtenerOrdenesReferenciaMaquina();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  eliminar({rowData}) {
    this.loading = true;
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        text: `Material: ${rowData.material}, Cantidad: ${rowData.cantidad}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this.ordenesReferenciaMaquinaS.borrar(rowData.numOrd),
      })
      .then((res: any) => {
        this.obtenerOrdenesReferenciaMaquina();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  editar({rowData}) {
    this.isCreate = false;
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;
    this.formOrdernes.reset();
    rowData.fechaOrd = formatDate(new Date(rowData.fechaOrd), 'dd-MM-yyyy HH:mm:ss', 'en')
    this.formOrdernes.patchValue(rowData);
    this.searchMaterial();
    this.formOrdernes.get('materialDescripcion').disable();
    this.openModal();
  }

  nueva() {
    this.isCreate = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.formOrdernes.reset();
    this.formOrdernes.get('fechaOrd').setValue(
      formatDate(new Date(), 'dd-MM-yyyy HH:mm:ss', 'en')
    );
    this.formOrdernes.get('materialDescripcion').disable();
    this.openModal();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreate) this.guardarCrear();
    if (!this.isCreate) this.guardarEditar();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }
}
